import React from "react";
import { ComponentCategory } from "./types";

interface CategoryFiltersProps {
  categories: ComponentCategory[];
  activeCategory: string;
  setActiveCategory: (category: string) => void;
}

const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  categories,
  activeCategory,
  setActiveCategory
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map(category => (
        <button
          key={category.id}
          onClick={() => setActiveCategory(category.id)}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-full transition-all duration-200 h-8 ${
            activeCategory === category.id 
              ? "bg-primary text-primary-foreground shadow-sm shadow-primary/20" 
              : "bg-black/50 text-foreground hover:bg-primary/10 border border-white/5"
          }`}
        >
          <span className="opacity-80">{category.icon}</span>
          <span>{category.name}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilters;
